var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"google-map"},[_c('iframe',{staticClass:"map-iframe",staticStyle:{"border":"0"},attrs:{"src":"https://maps.google.com/maps?q=19.06200459281623,73.01976163768549&z=15&output=embed","allowfullscreen":"","loading":"lazy","referrerpolicy":"no-referrer-when-downgrade"}})])
}]

export { render, staticRenderFns }